import {
  getAssignmentByIdUrl,
  getAssignmentResultsUrl,
  getAssignmentsByPlanId,
  getAssignmentsBySectionUrl,
  getFacultiesUrl,
} from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class AssignmentService {
  static getAssignmentsByPlanId = (planId) => {
    return getRequest(getAssignmentsByPlanId(planId));
  };

  static getAssignmentByFacultyId = (facultyId) => {
    return getRequest(getFacultiesUrl() + "/" + facultyId + "/assignments");
  };

  static getAssignmentResults = (id) => {
    let params = { assignmentId: id };
    return getRequest(getAssignmentResultsUrl(), params);
  };

  static getAssignmentById = (id) => {
    return getRequest(getAssignmentByIdUrl(id));
  };

  static getAssignmentsBySectionId = (canvasSectionId) => {
    return getRequest(getAssignmentsBySectionUrl(canvasSectionId));
  };
}
